import PropertyControlTable from './PropertyControlTable';

export default PropertyControlTable;
